'use client';
import React, { ChangeEvent, memo, useCallback, useEffect, useMemo, useState } from 'react';

import { EXIST_LOCAL_STORAGE } from '@/services/constants';
import { setCookie } from '@/services/helperFunctions/serverHelperFunctions';
import { makeNavigationSiteAnalytics } from '@/services/simpleApis';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import debounce from 'lodash/debounce';
import  { ChangeResult } from 'multi-range-slider-react';
const RangeSlider = dynamic(() => import('multi-range-slider-react'), { ssr: false });
import Link from 'next/link';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonAction from '../../redux/actions/common';
import { decodeHTML, getCookie } from '../../services/helperFunctions';
import dynamic from 'next/dynamic';

const SearchFormLandingPage = ({
    getCountry,
    getCurrency,
    getRegion,
    getIndustry,
    getIssueType,
    getMaturityYears,
    regionData,
    countryData,
    maturityData,
    issueTypeData,
    industryData,
    currencyData,
}: any) => {
    const [loading, setLoading] = useState(true);
    const currentYear = new Date().getFullYear();
    const [testSlider, setTestSilder] = useState({
        maturity_from_year: currentYear,
        maturity_to_year: currentYear + 100,
        coupon_from: 0,
        coupon_to: 30,
        test_from: 0,
        test_to: 30,
    });

    const user_id = useMemo(() => getCookie(EXIST_LOCAL_STORAGE.USER_ID) || '', []);

    const [filterObj, setFilterObj] = useState({
        issuer: '',
        issue_type: 'All bonds',
        user_id,
        country: '',
        currency: '',
        fulltext: '',
        region: '',
        industry: '',
        coupon_from: 0,
        coupon_to: 30,
        yield_from: 0,
        yield_to: 30,
        maturity_from_year: currentYear,
        maturity_to_year: currentYear + 100,
        callable: false,
        status: false,
        page_no: 1,
        sorting_column_sorting_order: 'bond_name asc',
    });

    useEffect(() => {
        // const status = filterObj?.status ? 'Active' : '';
        setCookie(
            EXIST_LOCAL_STORAGE.BOND_FILTER_OBJ,
            JSON.stringify({
                ...filterObj,
            })
        );
    }, [filterObj]);

    const handleInputChange = useCallback(
        (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, name: string) => {
            const target = event.target;
            const value = target.type === 'checkbox' ? target.checked : target.value;
            setFilterObj({
                ...filterObj,
                [name]: value,
                page_no: 1,
            });
        },
        [filterObj]
    );
    const handleTestSlider = useCallback(
        (e: ChangeResult, from: 'maturity_from_year' | 'coupon_from' | 'test_from', to: 'maturity_to_year' | 'coupon_to' | 'test_to') => {
            setFilterObj({
                ...filterObj,
                [from === 'test_from' ? 'yield_from' : from]: e.minValue,
                [to === 'test_to' ? 'yield_to' : to]: e.maxValue,
                page_no: 1,
            });
        },
        [filterObj]
    );

    let sliderHandleTest = false;
    const handleTestSliderInput = async (e: ChangeEvent, from: string, to: string) => {
        await debouncedHandleSliderTest(e, from, to);
    };
    const debouncedHandleSliderTest = debounce((e, from, to) => {
        setTestSilder((pre) => {
            return {
                ...pre,
                [from]: e.minValue,
                [to]: e.maxValue,
            };
        });
        setFilterObj({
            ...filterObj,
            [from]: e.minValue,
            [to]: e.maxValue,
            page_no: 1,
        });
        if (from === 'test_from' || to === 'test_to') {
            // console.log("weowonchange: ", e.minValue, '-', e.maxValue, 'testSlider: ', testSlider?.test_from, '-', testSlider?.test_to);
            if (!sliderHandleTest) {
                sliderHandleTest = true;

                return () => {
                    sliderHandleTest = false;
                };
            }
        } else {
            // console.log("handle slider else1");
            if (!sliderHandleTest) {
                sliderHandleTest = true;
                return () => {
                    sliderHandleTest = false;
                };
            }
        }
    }, 500);

    let isLoadingDropwValues = false;

    const isCommonDataAvailable = !!countryData.code && !!currencyData.code && !!industryData.code && !!regionData.code;

    const countryDataToMap = useMemo(() => countryData?.data, [countryData?.data?.length]);
    const remainingCurrencyDataToMap = useMemo(() => currencyData?.data?.remaining, [currencyData?.data?.remaining?.length]);
    const topCurrencyDataToMap = useMemo(() => currencyData?.data?.top_currencies, [currencyData?.data?.top_currencies?.length]);
    const industryDataToMap = useMemo(() => industryData?.data, [industryData?.data?.length]);
    const regionDataToMap = useMemo(() => regionData?.data, [regionData?.data?.length]);
    const issueTypeDataToMap: Array<{ name: string; value: string }> | null = useMemo(() => issueTypeData?.data, [issueTypeData?.data]);

    const min_maturity_year = !filterObj.status ? currentYear : currentYear - 1;
    const max_maturity_year = currentYear + 100;

    useEffect(() => {
        if (min_maturity_year && max_maturity_year)
            setFilterObj({
                ...filterObj,
                maturity_from_year: min_maturity_year,
                maturity_to_year: max_maturity_year,
            });
    }, [min_maturity_year, max_maturity_year]);

    useEffect(() => {
        if (isLoadingDropwValues || isCommonDataAvailable) {
            setLoading(false);
            return;
        }
        isLoadingDropwValues = true;
        Promise.all([getCountry(), getCurrency(), getRegion(), getIndustry(), getIssueType()])
            .then(() => setLoading(false))
            .catch((e) => console.log('error', e));
    }, [isCommonDataAvailable]);

    return (
        <>
            <div className="row  rounded mb-2 ">
                <div className="col-lg col-sm-12">
                    <label htmlFor="issuer-name" className="px-1 fw-bold search-form-lable search-form-lable">
                        Issuer name
                    </label>
                    <input
                        id="issuer-name"
                        name="issuer-name"
                        placeholder="Issuer name"
                        className="form-control input-style-searchform mb-3 mb-lg-0"
                        type="text"
                        aria-label="issuer-name"
                        value={filterObj?.issuer}
                        onChange={(e) => handleInputChange(e, 'issuer')}
                        style={{ height: '28px' }}
                    />
                </div>
                <div className="col-lg col-sm-12 ">
                    <label className="px-1 fw-bold search-form-lable" htmlFor="issue_type">
                        Issue type
                    </label>
                    <select
                        id="issue_type"
                        name="issue_type"
                        className="form-select input-style-searchform form-select-sm input-style-searchform mb-3 mb-lg-0"
                        aria-label="Default select example"
                        onChange={(e) => handleInputChange(e, 'issue_type')}
                        value={filterObj?.issue_type}
                    >
                        {!!issueTypeDataToMap &&
                            issueTypeDataToMap.map((issueType) => (
                                <option value={issueType?.value} key={issueType.value} defaultValue="All bonds">
                                    {decodeHTML(issueType?.name)}
                                </option>
                            ))}
                    </select>
                </div>
                <div className="col-lg col-sm-12">
                    <label className="px-1 fw-bold search-form-lable" htmlFor="region">
                        Region
                    </label>
                    <select
                        style={{ cursor: loading ? 'not-allowed' : '' }}
                        id="region"
                        name="region"
                        className="form-select form-select-sm input-style-searchform mb-3 mb-lg-0"
                        aria-label="Default select example"
                        onChange={(e) => handleInputChange(e, 'region')}
                        value={filterObj?.region}
                    >
                        <option value="">-All-</option>
                        {regionDataToMap &&
                            regionDataToMap.map((region, index) => (
                                <option key={index} value={region.region}>
                                    {region.region}
                                </option>
                            ))}
                    </select>
                </div>
                <div className="col-lg col-sm-12">
                    <label className="px-1 fw-bold search-form-lable" htmlFor="country">
                        Country
                    </label>
                    <select
                        style={{ cursor: loading ? 'not-allowed' : '' }}
                        id="country"
                        name="country"
                        className="form-select form-select-sm input-style-searchform mb-3 mb-lg-0"
                        aria-label="Default select example"
                        onChange={(e) => handleInputChange(e, 'country')}
                        value={filterObj?.country}
                    >
                        <option value="">-All-</option>
                        {countryDataToMap &&
                            countryDataToMap.map((country, index) => (
                                <option key={index} value={country?.country_code}>
                                    {country?.country_name}
                                </option>
                            ))}
                    </select>
                </div>
                <div className="col-lg col-sm-12">
                    <label className="px-1 fw-bold search-form-lable" htmlFor="industry">
                        Industry
                    </label>
                    <select
                        id="industry"
                        name="industry"
                        className="form-select form-select-sm input-style-searchform mb-3 mb-lg-0"
                        aria-label="Default select example"
                        onChange={(e) => handleInputChange(e, 'industry')}
                        value={filterObj?.industry}
                    >
                        <option value="">-All-</option>
                        {industryDataToMap &&
                            industryDataToMap.map((industry, index) => (
                                <option key={index} value={industry?.industry}>
                                    {industry?.industry}
                                </option>
                            ))}
                    </select>
                </div>
            </div>
            <div className="row">
                <div className="col-lg col-sm-12">
                    <label className="px-1 fw-bold search-form-lable" htmlFor="currency">
                        Currency
                    </label>
                    <select
                        id="currency"
                        name="currency"
                        className="form-select form-select-sm input-style-searchform mb-3 mb-lg-0"
                        aria-label="Default select example"
                        onChange={(e) => handleInputChange(e, 'currency')}
                        value={filterObj?.currency}
                    >
                        <option value="">-All-</option>
                        {topCurrencyDataToMap &&
                            topCurrencyDataToMap.map((currency, index) => (
                                <option key={index} value={currency?.currency_code}>
                                    {currency?.currency_name}
                                </option>
                            ))}
                        <option value="" disabled>
                            {' '}
                            ----{' '}
                        </option>
                        {remainingCurrencyDataToMap &&
                            remainingCurrencyDataToMap.map((currency, index) => (
                                <option key={index} value={currency?.currency_code}>
                                    {currency?.currency_name}
                                </option>
                            ))}
                    </select>
                </div>
                <div className="col-lg col-sm-12 mt-1">
                    <label className=" fw-bold search-form-lable  px-1">
                        Maturity{' '}
                        <small>
                            {filterObj?.maturity_from_year} - {filterObj?.maturity_to_year}
                            {filterObj.maturity_to_year === max_maturity_year ? '+' : ''}
                        </small>
                    </label>
                    <RangeSlider
                        style={{
                            minWidth: '200px',
                            // minWidth: "300px",
                            // width: "100%",
                            border: 'none',
                            boxShadow: 'none',
                            padding: '5px 5px',
                            paddingLeft: '13px',
                            paddingRight: '10px',
                        }}
                        className={`  ${loading ? 'disabled-slider' : ''}`}
                        label="false"
                        ruler="false"
                        barLeftColor="#808080"
                        barInnerColor="#1E90FF"
                        barRightColor="#808080"
                        thumbLeftColor="#ccc"
                        thumbRightColor="#ccc"
                        min={min_maturity_year}
                        max={max_maturity_year}
                        step={1}
                        minValue={filterObj.maturity_from_year}
                        maxValue={filterObj.maturity_to_year}
                        onChange={(e: ChangeResult) => handleTestSlider(e, 'maturity_from_year', 'maturity_to_year')}
                        onInput={(e: ChangeEvent) => handleTestSliderInput(e, 'maturity_from_year', 'maturity_to_year')}
                    />
                </div>
                <div className="col-lg col-sm-12 mt-1">
                    <label className=" fw-bold search-form-lable  px-1">
                        Coupon %{' '}
                        <small>
                            ({filterObj?.coupon_from} - {filterObj?.coupon_to}
                            {filterObj?.coupon_to === 30 ? '+' : ''})
                        </small>
                    </label>
                    <RangeSlider
                        style={{
                            minWidth: '200px',
                            border: 'none',
                            boxShadow: 'none',
                            padding: '5px 5px',
                            paddingLeft: '13px',
                            paddingRight: '10px',
                        }}
                        className={`  ${filterObj?.coupon_to === 30 ? 'thumb-coupon' : 'thumb-coupon1'} ${
                            loading ? 'disabled-slider' : ''
                        }`}
                        label="false"
                        ruler="false"
                        barLeftColor="#808080"
                        barInnerColor="#1E90FF"
                        barRightColor="#808080"
                        thumbLeftColor="#ccc"
                        thumbRightColor="#ccc"
                        min={0}
                        max={30}
                        step={1}
                        minValue={filterObj?.coupon_from}
                        maxValue={filterObj?.coupon_to}
                        onChange={(e: ChangeResult) => handleTestSlider(e, 'coupon_from', 'coupon_to')}
                        onInput={(e: ChangeEvent) => handleSliderInputChange(e, 'coupon_from', 'coupon_to')}
                    />
                </div>
                <div className="col-lg col-sm-12 mt-1">
                    <label className=" fw-bold search-form-lable  px-1">
                        Yield %{' '}
                        <small>
                            ({filterObj?.yield_from} - {filterObj?.yield_to}
                            {filterObj?.yield_to === 30 ? '+' : ''})
                        </small>
                    </label>
                    <RangeSlider
                        style={{
                            minWidth: '200px',
                            // width: '275px',
                            border: 'none',
                            boxShadow: 'none',
                            padding: '5px 5px',
                            paddingLeft: '13px',
                            paddingRight: '10px',
                        }}
                        className={` ${filterObj?.test_to === 30 ? 'thumb-yield' : 'thumb-yield1'} ${
                            loading ? 'disabled-slider cursor-not-allowed  ' : ''
                        }`}
                        disabled={loading}
                        label="false"
                        ruler="false"
                        barLeftColor="#808080"
                        barInnerColor="#1E90FF"
                        barRightColor="#808080"
                        thumbLeftColor="#ccc"
                        thumbRightColor="#ccc"
                        min={0}
                        max={30}
                        step={1}
                        minValue={filterObj?.yield_from}
                        maxValue={filterObj?.yield_to}
                        onChange={(e: ChangeResult) => handleTestSlider(e, 'yield_from', 'yield_to')}
                    />
                </div>
                <div className="col-lg col-sm-12 d-flex align-items-end">
                    <div className="d-flex mt-1">
                        <label className=" fw-bold search-form-lable form-label px-1 d-flex align-items-center gap-2">
                            <input
                                id="callable"
                                name="callable"
                                type="checkbox"
                                style={{ scale: '1.2' }}
                                onChange={(e) => handleInputChange(e, 'callable')}
                                value={filterObj?.callable}
                                checked={filterObj?.callable === true ? true : false}
                            />
                            <span className="ps-1 fw-bold ">Exclude Callable</span>
                        </label>
                        <label className=" fw-bold search-form-lable form-label px-1 d-flex align-items-center gap-2">
                            <input
                                type="checkbox"
                                onChange={(e) => handleInputChange(e, 'status')}
                                checked={filterObj?.status}
                                style={{ scale: '1.2' }}
                            />
                            <span className="ps-1">Include Inactive</span>
                        </label>
                    </div>
                </div>
            </div>
            <div className="row pb-3">
                <div className="col-lg-5 col-sm-12 "></div>
                <div className="col-lg-2 col-sm-12 mt-3 d-flex justify-content-center">
                    <Link
                        href="/screener"
                        onClick={() => void makeNavigationSiteAnalytics('view results', '/screener')}
                        className="view-results-button no-underline w-100 rounded border-0 text-center"
                        style={{ backgroundColor: '#294672', color: 'white', fontSize: '14px', padding: '.8rem 2rem' }}
                    >
                        <FontAwesomeIcon icon={faMagnifyingGlass} /> View Results
                    </Link>
                </div>
            </div>
        </>
    );
};

const mapStatesToProps = ({
    common: {
        countryData = {},
        isCountryLoader = false,
        issueTypeData = {},
        maturityData = {},
        regionData = {},
        industryData = {},
        currencyData = {},
    },
}: any) => {
    return {
        isCountryLoader,
        maturityData,
        regionData,
        industryData,
        currencyData,
        issueTypeData,
        countryData,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return bindActionCreators(
        {
            ...commonAction,
        },
        dispatch
    );
};

export default memo(connect(mapStatesToProps, mapDispatchToProps)(SearchFormLandingPage));
